type PromiseFunction<T> = () => Promise<T>;

export const retryPromise = async <T>(
  promiseFunction: PromiseFunction<T>,
  maxRetries = 3,
  delay = 1000
) => {
  let lastError;

  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      return await promiseFunction();
    } catch (error) {
      lastError = error;
      if (attempt === maxRetries) {
        throw lastError;
      }

      // Wait before retrying (exponential backoff)
      await new Promise(resolve => setTimeout(resolve, delay * attempt));
    }
  }
};
